import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../../../../redux/features/auth/authSlice";
import { MaritalStatusService } from "../service/MaritalStatusService";

import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { DataGrid } from "@mui/x-data-grid";
import ButtonManager from "../../../../shared/components/Button/ButtonManager";
//import "./MaritalStatusListing.css";

const columns = [
  { field: "id", headerName: "Id", hideable: true, flex: 1, headerClassName: "researchColmun", headerAlign: "center", align: "center", },
  { field: "description", headerName: "Description", flex: 1, headerClassName: "researchColmun", headerAlign: "center", align: "center", },
  { field: "deleted", headerName: "Actif", flex: 1, headerClassName: "researchColmun", headerAlign: "center", align: "center", 
      renderCell: (data) => (data.value === false) ? <DoneIcon color="success" /> : <CloseIcon color="warning" /> 
  },
];

const forms = [
  { name: "description", label: "Description", },
  { name: "deleted", label: "Supprimé", type: "checkbox" },
];

const MaritalStatusListing = () => {
  const dispatch = useDispatch();

  const pageSize = 10;
  const [rows, setRows] = useState([]);
  const [select, setSelect] = useState(null);

  const loadData = () => {
    return MaritalStatusService.getMaritalStatus(-1, 0)
      .then((response) => {
        const data = response.data.content.sort((maritalStatus1, maritalStatus2) =>
          maritalStatus1.description.localeCompare(maritalStatus2.description)
        );
        setRows(
          data.map((row) => {
            const { maritalStatusId, ...rest } = row;
            return { id: maritalStatusId, ...rest };
          })
        );
        let selected = data.filter((maritalStatus) => maritalStatus.maritalStatusId === select.maritalStatusId);
        setSelect(selected.length ? selected[0] : null);
      })
      .catch((err) => {
        if (err?.statusCode === 403 || err?.statusCode === 401 
          || err?.response?.status === 403 || err?.response?.status === 401
        ) {
            dispatch(logout());
        }
      });
  };

  useEffect(() => { loadData() }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', justifyContent: 'center', width: '100%' }}>
      <h1 style={{ fontFamily: 'backToSchool', fontSize: '65px', color: '#bb0000', marginTop: '4%' }}>Etat civil</h1>
      <div style={{ position: 'absolute', top: 23, left: 270 }}>
        <Link to="/SettingsSelect">
          <IconButton color='primary'>
            <ArrowBackIosNewIcon />
          </IconButton>
        </Link>
      </div>
      <div className="event-container display-relative" style={{ marginTop:'5%' }}>
        <ButtonManager
          isContained={true}
          title={"état civil"}
          id={select?.maritalStatusId}
          selected={select}
          align={"center"}
          forms={forms}
          createFunction={MaritalStatusService.createMaritalStatus}
          updateFunction={MaritalStatusService.updateMaritalStatus}
          deleteFunction={MaritalStatusService.deleteMaritalStatus}
          requiredFields={["description"]}
          requiredFieldLabel={["Description"]}
          refresh={loadData}
        />

        <div className="EventDataGrid">
          <DataGrid
            rows={rows}
            columns={columns}
            autoPageSize={true}
            showCellRightBorder
            rowsPerPageOptions={[pageSize]}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRowData = rows.filter((row) =>
                selectedIDs.has(row?.id?.toString())
              );
              if (selectedRowData.length) {
                const { id, ...rest } = selectedRowData[0];
                setSelect({ maritalStatusId: id, ...rest });
              } else {
                setSelect(null);
              }
            }}
            columnVisibilityModel={{
              id: false,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MaritalStatusListing;
